export const ACCESS_TOKEN = 'Access-Token'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'
export const DEFAULT_THEME = 'DEFAULT_THEME'
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE'
export const DEFAULT_COLOR = 'DEFAULT_COLOR'
export const DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK'
export const DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER'
export const DEFAULT_FIXED_SIDEMENU = 'DEFAULT_FIXED_SIDEMENU'
   export const USER_NAME = 'Login_Username'
export const USER_INFO = 'Login_Userinfo'
export const USER_AUTH = 'LOGIN_USER_BUTTON_AUTH'
export const SYS_BUTTON_AUTH = 'SYS_BUTTON_AUTH'
export const ENCRYPTED_STRING = 'ENCRYPTED_STRING'
export const ENHANCE_PRE = 'enhance_'
export const UI_CACHE_DB_DICT_DATA = 'UI_CACHE_DB_DICT_DATA'
export const INDEX_MAIN_PAGE_PATH = '/dashboard'
export const TENANT_ID = 'TENANT_ID'
export const ONL_AUTH_FIELDS = 'ONL_AUTH_FIELDS'
export const LOCATION_SOURCE = 'LOCATION_SOURCE'
 export const LOCATION_TYPE = 'LOCATION_TYPE'
export const OA_ID = 'OA_ID'
export const OA_TASK_ID = 'OA_TASK_ID'
export const WEEKLY_NUMBER = 'WEEKLY_NUMBER'
export const MONTH_NUMBER = 'MONTH_NUMBER'
export const FIRMWARE_PERMISSIONS = 'FIRMWARE_PERMISSIONS'
export const IS_SMS_VERIFY = 'IS_SMS_VERIFY'
export const LOCATION_NAME = 'LOCATION_NAME'
export const LOCATION_PASSWORD = 'LOCATION_PASSWORD'
export const LOCATION_INPUTCODE = 'LOCATION_INPUTCODE'

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}
